
import Vue from 'vue';


//自定义权限验证组件
import auth from './auth/auth' //

// ******************************角色权限相关
//权限选择组件
import SHPermission from './role/permission/index.js'
Vue.use(SHPermission);
//角色编辑组件
import SHRoleEdit from './role/edit/index.js'
Vue.use(SHRoleEdit);
//角色选择组件
import SHRolePicker from './role/picker/index.js'
Vue.use(SHRolePicker);
//角色选择组件（弹窗）
import SHRoleDialog from './role/dialog/index.js'
Vue.use(SHRoleDialog);

// **********************机构相关
//组织机构树组件
import SHOrgTree from './org/tree/index.js'
Vue.use(SHOrgTree);

//组织机构选择组件
import SHOrgPicker from './org/picker/index.js'
Vue.use(SHOrgPicker);
//组织机构选择弹窗组件
import SHOrgDialog from './org/dialog/index.js'
Vue.use(SHOrgDialog);

// ***********************人员相关
//人员选择控件
import SHUserPicker from './user/picker/index.js'
Vue.use(SHUserPicker);

//人员选择弹窗组件
import SHUserDialog from './user/dialog/index.js'
Vue.use(SHUserDialog);

//用户界面顶部显示组件
import SHUserDisplay from './user/display/index.js'
Vue.use(SHUserDisplay);


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/cmps.js